



import Vue from 'vue'

export type DataType = {
  submitImage: any
}
export default Vue.extend({
  data(): DataType {
    return {
      submitImage: require('@/assets/img/top_menu13.png')
    }
  },
  computed: {
    pdfURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/overseas_download`
    },
    manabiURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/manabi`
    },
 },
})
